import axios from "axios"
import { URL } from "./settings"

export default class ScoreService {
    static async getStudentsScores() {
        const response = await axios.post(`${URL}/my-students/collecting_points/`,
            {},
            { withCredentials: true }
        )
        return response
    }

    static async getScoresTags() {
        try {
            const response = await axios.get(`${URL}/my-students/collecting_points/tags`,
                { withCredentials: true }
            )
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateScoreTag(siteId, tagId, classTypeId) {
        const response = await axios.patch(`${URL}/my-students/collecting_points/tag`,
            {
                tag_id: tagId,
                site_id: siteId,
                class_type_id: classTypeId,
            },
            { withCredentials: true },
        )
        return response
    }

    static async resetScoreTag(siteId, classTypeId) {
        const response = await axios.delete(`${URL}/my-students/collecting_points/tag`,
            {
                data: {
                    site_id: siteId,
                    class_type_id: classTypeId,
                },
                withCredentials: true,
            },
        )
        return response
    }

    static async updateScore(siteId, email, classYear, classType, points) {
        const response = await axios.patch(`${URL}/my-students/collecting_points/update_points`,
            {
                site_id: siteId,
                email: email,
                class_year: classYear,
                class_type: classType,
                points: points,
            },
            { withCredentials: true },
        )
        return response
    }

    static async updateScoreComment(siteId, classTypeId, comment) {
        const response = await axios.patch(`${URL}/my-students/collecting_points/comment`,
            {
                site_id: siteId,
                class_type_id: classTypeId,
                comment: comment,
            },
            { withCredentials: true },
        )
        return response
    }

    static async updateIsContacted(siteId, checked) {
        const response = await axios.patch(`${URL}/my-students/collecting_points/${siteId}/is_contacted`,
            {},
            {
                params: { is_contacted: checked },
                withCredentials: true,
            }
        )
        return response
    }

    static async addConfirmationFiles(formData) {
        const response = await axios.post(`${URL}/my-students/collecting_points/confirmation_file`,
            formData,
            { withCredentials: true }
        )
        return response
    }

    static async deactivateConfirmationFile(fileId) {
        const response = await axios.patch(
            `${URL}/my-students/collecting_points/confirmation_file/${fileId}/deactivate`,
            {},
            { withCredentials: true }
        )
        return response
    }

    static async addScanFiles(formData) {
        const response = await axios.post(`${URL}/my-students/collecting_points/scan_work`,
            formData,
            { withCredentials: true }
        )
        return response
    }

    static async deleteScanFile(scanStorageId) {
        const response = await axios.delete(`${URL}/my-students/collecting_points/scan_work`, {
            data: { scan_storage_id: scanStorageId },
            withCredentials: true,
        })
        return response
    }

    static async updateParentPhone(siteId, parentPhone) {
        const response = await axios.patch(`${URL}/student/${siteId}/`,
            { parent_phone: parentPhone },
            { withCredentials: true }
        )
        return response
    }

    static async updateVerifedOKK(siteId, checked) {
        const response = await axios.patch(
            `${URL}/my-students/collecting_points/${siteId}/is_checked_by_qc`,
            {},
            {
                params: { is_checked_by_qc: checked },
                withCredentials: true,
            }
        )
    }
}
